const TOGGLE_SELECTOR = ".seo-content__text-toggle";
const COLLAPSIBLE_CLASS = "is-collapsible";
const OPEN_CLASS = "is-open";

const initSeoContent = (): void => {
  const btn = document.querySelector(TOGGLE_SELECTOR);
  if (!(btn instanceof HTMLButtonElement)) return;

  btn.classList.add("is-ready");

  const id = btn.getAttribute("aria-controls");
  const wrap = id ? document.getElementById(id) : null;
  if (!wrap) return;

  wrap.classList.add(COLLAPSIBLE_CLASS);
  const expanded = btn.getAttribute("aria-expanded") === "true";
  wrap.setAttribute("aria-hidden", String(!expanded));
  if (expanded) {
    wrap.classList.add(OPEN_CLASS);
    wrap.style.maxHeight = `${wrap.scrollHeight}px`;
  }

  btn.addEventListener("click", () => {
    const isExpanded = btn.getAttribute("aria-expanded") === "true";

    if (!isExpanded) {
      btn.setAttribute("aria-expanded", "true");
      wrap.classList.add(OPEN_CLASS);
      wrap.setAttribute("aria-hidden", "false");
      requestAnimationFrame(() => {
        wrap.style.maxHeight = `${wrap.scrollHeight}px`;
      });
    } else {
      btn.setAttribute("aria-expanded", "false");
      wrap.style.maxHeight = `${wrap.scrollHeight}px`;
      requestAnimationFrame(() => {
        wrap.classList.remove(OPEN_CLASS);
        wrap.setAttribute("aria-hidden", "true");
        wrap.style.maxHeight = "";
      });
    }

    const labelMore = btn.dataset.labelMore;
    const labelLess = btn.dataset.labelLess;
    const span = btn.querySelector("span");
    if (span && labelMore && labelLess) {
      span.textContent = isExpanded ? labelMore : labelLess;
    }
  });
};

initSeoContent();